/* global axios */
import ApiClient from './ApiClient';

class EmailHistoryAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  status(id) {
    return axios.get(`${this.url}/${id}/email_history`);
  }

  request(id, action) {
    return axios.post(`${this.url}/${id}/email_history`, { action_type: action });
  }
}

export default new EmailHistoryAPI();
